export enum FLightOrderStatusEnum {
    COMPLETED = 'COMPLETED',
}